import { h, Component, Fragment } from "preact";
import Observer from "../../utils/observer";
import Config from "../../config";
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import Session from "../../utils/session";
import ProfilePage from "./menu-profile";
import TransactionsHistoryPage from "./menu-transaction-history";
import BetsHistoryPage from "./menu-bets-history";
import CashoutPage from "./menu-cashout";
import DashboardPage from "./menu-dashboard";
import PymentGatewayPage from "./menu-payment-gateway";
import ManagerReport from "./manager-report";
import { BonusStatusPage } from "./menu-bonus-status";

import * as I from "../../utils/icons";
import { VouchersPage } from "./menu-vouchers";

import AwrabetMenuPopup from "../../../awrabet/desktop-components/user/menu-popup";

export default class MenuPopup extends AwrabetMenuPopup {
	drawHeader() {
		const isManager = !!Session.fetch('manager');
		return <HeaderContainer onClose={e => this.setState({visible: false})}>
			<div class="w-full flex gap-2 justify-end h-full">
				{!isManager && <Fragment>
					<HeaderButton onClick={e => this.setState({currentpage:'transactions'})} selected={this.state.currentpage==='transactions'}>
						<div class="h-8 flex items-center justify-center"><I.TransactionsIcon class="block h-6" /></div>
						<div class="h-4"><Trans>Movimenti</Trans></div>
					</HeaderButton>
					<HeaderButton onClick={e => this.setState({currentpage:'bets'})} selected={this.state.currentpage==='bets'}>
						<div class="h-8 flex items-center justify-center"><I.BetsIcon class="block h-6" /></div>
						<div class="h-4"><Trans>Scommesse</Trans></div>
					</HeaderButton>
					<HeaderButton onClick={e => this.setState({currentpage:'cashouts'})} selected={this.state.currentpage==='cashouts'}>
						<div class="h-8 flex items-center justify-center"><I.CashoutIcon class="h-6" /></div>
						<div class="h-4"><Trans>Cashouts</Trans></div>
					</HeaderButton>
					<HeaderButton onClick={e => this.setState({currentpage:'payment-gateway'})} selected={this.state.currentpage==='payment-gateway'}>
						<div class="h-8 flex items-center justify-center"><I.TransactionsIcon class="block h-6" /></div>
						<div class="h-4"><Trans>Deposit</Trans></div>
					</HeaderButton>
					<HeaderButton onClick={e => this.setState({currentpage:'vouchers'})} selected={this.state.currentpage==='vouchers'}>
						<div class="h-8 flex items-center justify-center"><I.TransactionsIcon class="block h-6" /></div>
						<div class="h-4"><Trans>Vouchers</Trans></div>
					</HeaderButton>
					{/* Bonus Status Button Added */}
					<HeaderButton onClick={e => this.setState({currentpage:'bonus-status'})} selected={this.state.currentpage==='bonus-status'}>
						<div class="h-8 flex items-center justify-center"><I.BonusIcon class="block h-6" /></div>
						<div class="h-4"><Trans>Bonus</Trans></div>
					</HeaderButton>
				</Fragment>}
				{false && <HeaderButton onClick={e => this.setState({currentpage:'messages'})} selected={this.state.currentpage==='messages'}>
					<div class="h-8 flex items-center justify-center"><I.MessageIcon class="h-6" /></div>
					<div class="h-4"><Trans>Messaggi</Trans></div>
				</HeaderButton>}
				<HeaderButton onClick={e => this.setState({currentpage:'profile'})} selected={this.state.currentpage==='profile'}>
					<div class="h-8 flex items-center justify-center"><I.UserIcon class="h-6" /></div>
					<div class="h-4"><Trans>Account</Trans></div>
				</HeaderButton>
				{!!Session.fetch('club') && !Session.fetch('manager') && <Fragment>
					<div class="w-px bg-white mr-2 ml-px inline-block h-16 align-bottom" />
					<HeaderButton onClick={e => this.setState({currentpage:'dashboard'})} selected={this.state.currentpage==='dashboard'}>
						<div class="h-8 flex items-center justify-center"><I.PlayersIcon class="h-6" /></div>
						<div class="h-4"><Trans>Players</Trans></div>
					</HeaderButton>
					<HeaderButton onClick={e => this.setState({currentpage:'reports'})} selected={this.state.currentpage==='reports'}>
						<div class="h-8 flex items-center justify-center"><I.ReportsIcon class="h-6" /></div>
						<div class="h-4"><Trans>Reports</Trans></div>
					</HeaderButton>
				</Fragment>}
			</div>
		</HeaderContainer>;
	}

	render() {
		if (!this.state.visible || !Session.isActive())
			return null;
		return <Overlay onClick={e => this.setState({visible: false})}>
			<div id="user-menu-content" class="user-menu-content bg-white w-full max-w-6xl h-full max-h-[calc(100vh-170px)] flex flex-col" ref={e => this.root = e}>
				{this.drawHeader()}
				<section class="h-full overflow-auto">
					{this.state.currentpage === 'transactions' && <TransactionsHistoryPage />}
					{this.state.currentpage === 'bets' && <BetsHistoryPage />}
					{this.state.currentpage === 'cashouts' && <CashoutPage />}
					{this.state.currentpage === 'messages' && <ComingSoonSvg />}
					{this.state.currentpage === 'profile' && <ProfilePage />}
					{this.state.currentpage === 'dashboard' && <DashboardPage />}
					{this.state.currentpage === 'reports' && <ManagerReport usetree={false} />}
					{this.state.currentpage === 'payment-gateway' && <PymentGatewayPage />}
					{this.state.currentpage === 'vouchers' && <VouchersPage />}
					{this.state.currentpage === 'bonus-status' && <BonusStatusPage />}
				</section>
			</div>
		</Overlay>;
	}
}

export function Overlay({onClick, children}) {
	return <div class="fixed top-0 left-0 right-0 bottom-0 z-50 bg-slate-800/50 flex items-center justify-center" onClick={e => e.target == e.currentTarget ? onClick(e) : null}>
		{children}
	</div>
}

function HeaderButton({children, onClick, selected}) {
	if (selected)
		return <div class="w-24 p-2 font-sans flex flex-col items-center rounded bg-custom-orange  text-white cursor-pointer">
			{children}
		</div>
	return <div class="w-24 p-2 font-sans flex flex-col items-center hover:text-custom-orange cursor-pointer" onClick={onClick}>
		{children}
	</div>
}

function HeaderContainer({children, onClose}) {
	return (
		<header class="relative bg-harif-800 text-slate-100 h-24">
			<a
				onClick={onClose}
				class="top-3 right-3 z-10 absolute w-6 h-6 flex items-center justify-center cursor-pointer rounded"
			>
				<I.CloseIcon class="h-4 fill-current text-white" />
			</a>
			<div class="flex flex-row justify-center items-center pr-12">
				<div class="w-16" />
				<div class="shrink-0 p-4">
					<a class="header-logo" href="javascript:void(0);">
						<img
							src={Config.logourl}
							alt={Config.title}
							style="max-width: 244px;"
						/>
					</a>
				</div>
				{children}
			</div>
		</header>
	);
}

const ComingSoonSvg = () => null

//> Eof